// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --layout-width: 1420px; /* 1440px - 20px = 지원하는 최소 viewport - 안전 여백 */
}

.Layout-module__frame-Layout--TASK7 {
  min-width: var(--layout-width);
}

.Layout-module__env-development--NGiA5:before{
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: #FF9800;
}

.Layout-module__env-local--Bhb1n:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: #10B981;
}`, "",{"version":3,"sources":["webpack://./src/frames/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAE,6CAA6C;AACvE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[":root {\n  --layout-width: 1420px; /* 1440px - 20px = 지원하는 최소 viewport - 안전 여백 */\n}\n\n.frame-Layout {\n  min-width: var(--layout-width);\n}\n\n.env-development:before{\n  content: '';\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 10px;\n  background: #FF9800;\n}\n\n.env-local:before {\n  content: '';\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 10px;\n  background: #10B981;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame-Layout": `Layout-module__frame-Layout--TASK7`,
	"env-development": `Layout-module__env-development--NGiA5`,
	"env-local": `Layout-module__env-local--Bhb1n`
};
export default ___CSS_LOADER_EXPORT___;
